import { useEffect, useState, ChangeEvent } from "react";
import { useUser } from "src/shared/context/UserContext";

export const usePagination = (initialRowsPerPage?: number) => {
  const { userConfigration } = useUser();

  const resolvedDefault = initialRowsPerPage ?? userConfigration?.tableDefaultSize ?? 10;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(resolvedDefault);

  // 🔥 IMPORTANT: sync when config loads/changes
  useEffect(() => {
    if (userConfigration?.tableDefaultSize) {
      setRowsPerPage(userConfigration.tableDefaultSize);
      setPage(0);
    }
  }, [userConfigration?.tableDefaultSize]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = parseInt(event.target.value, 10);
    setRowsPerPage(value);
    setPage(0);
  };

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setPage,
    setRowsPerPage, // 👈 expose if needed
  };
};
